import mixpanel from "mixpanel-browser";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList } from "../../App";
import { lang } from "../../assets/languages/en.language";
import { usePushNotifications } from "../../hooks/usePushNotifications";
import { usePwaViewportWidth } from "../../hooks/useScreenWidth";
import api from "../../services/api";
import { getVpFontSize } from "../../services/utils";
import { useUserStore } from "../../store/useUserStore";
import { PurpleButton, SwitchButton } from "../../styles/Button.style";
import { MainContainer, RootContainer } from "../../styles/Container.style";
import { BigTitle } from "../../styles/Text";
import { Gap, Row } from "../../styles/Utils";


export default function NotificationsPage() {
  const navigate = useNavigate();
  const { getPushPermission, permission: pushPermission } = usePushNotifications();

  const {
    profile: { notificationFlags },
    setNotifFlags: updateNotifs,
  } = useUserStore();

  const { email, push = false, matchs, messages } = notificationFlags!;
  const [emailNotifEnable, setEmailNotifEnable] = useState<boolean>(email);
  const [pushNotifEnable, setPushNotifEnable] = useState<boolean>(push);
  const [matchsNotifEnable, setMatchsNotifEnable] = useState<boolean>(matchs);
  const [messagesNotifEnable, setMessagesNotifEnable] = useState<boolean>(messages);

  const theme = useTheme();
  const viewportWidth = usePwaViewportWidth();

  const { profile } = useUserStore();
  console.log(profile);

  const handleSubmission = async () => {
    console.log(messagesNotifEnable, messages);
    try {
      await api.updateNotificationFlags({
        email: emailNotifEnable,
        push: pushNotifEnable,
        matchs: matchsNotifEnable,
        messages: messagesNotifEnable,
      });
      mixpanel.track("Update Notifications");
      updateNotifs({ email: emailNotifEnable, push: pushNotifEnable, matchs: matchsNotifEnable, messages: messagesNotifEnable });
      navigate(routeList.settings);
    } catch (err) {
      console.log("Error updating notification flags", err);
      alert("Error updating notification flags");
    }
  };

  console.log(emailNotifEnable, matchsNotifEnable, messagesNotifEnable);

  return (
    <RootContainer>
      <BigTitle $fontSize={getVpFontSize(viewportWidth, 10)}>{lang.notificationsPage.title}</BigTitle>
      <Gap $height={1} />
      <MainContainer $gap={1}>
        <ListItem
          $color={theme.color.tertiaryLight}
          $background={theme.color.primaryDark}
          $justifyContent="space-between"
          $alignItem="center"
        >
          <span>{lang.notificationsPage.title}</span>
          <SwitchButton
            size={2}
            checked={pushNotifEnable}
            onClick={async () => {
              if (!pushNotifEnable && pushPermission !== "granted") {
                const granted = await getPushPermission();
                console.log("granted getPushPermission", granted);
                if (granted) setPushNotifEnable(true);
              } else {
                setPushNotifEnable((prev) => !prev);
              }
            }}
          />
        </ListItem> 

        <ListItem
          $color={theme.color.tertiaryLight}
          $background={theme.color.primaryDark}
          $justifyContent="space-between"
          $alignItem="center"
        >
          <span>{lang.notificationsPage.notifViaEmail}</span>
          <SwitchButton size={2} checked={emailNotifEnable} onClick={() => setEmailNotifEnable((prev) => !prev)} />
        </ListItem>
        <ListItem
          $color={theme.color.tertiaryLight}
          $background={theme.color.primaryDark}
          $justifyContent="space-between"
          $alignItem="center"
          $disabled={!emailNotifEnable && !pushNotifEnable}
        >
          <span>{lang.notificationsPage.matchs}</span>
          <SwitchButton
            size={2}
            checked={(emailNotifEnable || pushNotifEnable) && matchsNotifEnable}
            onClick={() => setMatchsNotifEnable((prev) => !prev)}
          />
        </ListItem>
        <ListItem
          $color={theme.color.tertiaryLight}
          $background={theme.color.primaryDark}
          $justifyContent="space-between"
          $alignItem="center"
          $disabled={!emailNotifEnable && !pushNotifEnable}
        >
          <span>{lang.notificationsPage.messages}</span>
          <SwitchButton
            size={2}
            checked={(emailNotifEnable || pushNotifEnable) && messagesNotifEnable}
            onClick={() => setMessagesNotifEnable((prev) => !prev)}
          />
        </ListItem>
        <Gap $height={1} />
        <Image src="/illustrations/girl-hug-dog.png" />
      </MainContainer>
      <Gap $height={1} />
      <PurpleButton type="submit" onClick={handleSubmission}>
        <span>{lang.buttons.continue}</span>
      </PurpleButton>
    </RootContainer>
  );
}

const Image = styled.img`
  width: 80%;
  transform: translateY(3rem);
`;

const ListItem = styled(Row)<{
  $color: string;
  $background: string;
  $disabled?: boolean;
}>`
  width: 100%;
  padding-left: 1rem;
  border-radius: 100px;
  color: ${(props) => props.$color};
  background: ${(props) => props.$background};
  text-align: left;
  font-family: ${(props) => props.theme.font.family.main};
  border: none;
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};
  pointer-events: ${(props) => props.$disabled && "none"};
`;
